import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import { PlusOutlined,CloseOutlined,FileImageOutlined,VideoCameraOutlined } from '@ant-design/icons';
import { compose, withProps, withHandlers } from "recompose"
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps"

import axios from 'axios';
import RouteGoogleMap from "../../RouteGoogleMap";



const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}



class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {			
			payee_list: [],
			category_details: [],
			loading: false,		
			student_list: [],
			selectedMarker: false,
			student_list: [],	
			map_student: [],
			route_list: [],
      path: [],
			show_map_model:false
		}
		this.goBack = this.goBack.bind(this);
	}
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		this.checkData();
		setInterval(() => {
			//this.checkData();
		}, 6000);
	}
	
	checkData(){
		console.log('get_live_bus_list');
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {user_id : user_id,school_id:school_id}			
			getData('Transport/get_live_bus_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							student_list: result['data'],
						});
					}else{
						this.setState({
							student_list: [],
						});
					}
				}
			});	
		}
	}
    
	handleClick = (marker, event) => {
		this.setState({ selectedMarker: marker })
	}
 
    handleChange = ({ fileList }) => this.setState({ fileList });
	
	goBack(){
		window.location.href = '/expenses/index';
	}
	
	updatePositions=(p_array)=>{
		var student_array=Array();
		var student_list = this.state.student_list;
		p_array.forEach(cp => {
			student_list.forEach(st => {
				if(st.latitude==cp.latitude){
					student_array.push({
						name  : st.name
					});
				}
			});
		});
		this.setState({ map_student: student_array, show_map_model:true })
	}
	
		
	handleOk = e => {
		this.setState({
			show_map_model: false,
		})
	}

	handleCancel = e => {
		this.setState({
			show_map_model: false,
		})
	}
	
	render()
	{

			
		return (
		<>
		<div class="row bred map_model">
		<Modal 
				 title="Bus Information"
				 visible={this.state.show_map_model}
				 className="map_model"
				 onOk={this.handleOk}
				 onCancel={this.handleCancel}
				>
				<div class="student_box">
					{this.state.map_student.map((list,index) => (
						  <div class="student_list">
						  {index+1}. {list.name}
						  </div>
					))}
				</div>
			</Modal>
			
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<h4 class="page-title">
							<i class="mdi mdi-apple-keyboard-command title_icon"></i> Ongoing Route
							<div class="breadcrumb-wrapper">
								<ol class="breadcrumb">
									<li class="breadcrumb-item">
										<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
										<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
										</a>
									</li>
									<li class="breadcrumb-item">Bus On Map</li>
								</ol>
							</div>
						</h4>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="card-body">
				<ul class="nav nav-tabs nav-tabs-solid">
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/drivers`} class="nav-link ">Driver Profile</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/manage-bus`} class="nav-link ">Manage Bus</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/manage-route/stop`} class="nav-link ">Manage Route</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/assign-route-driver`} class="nav-link ">Assign Route & Driver</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/manage-student`} class="nav-link">Assign Student</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/check-route`} class="nav-link">Route Details</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/ongoing-route`} class="nav-link">Ongoing Route</Link></li>
					<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/transport-setup/bus-on-map`} class="nav-link active">Bus On Map</Link></li>
				</ul>
			</div>
		</div>
			<div class="">
			  <div class="row">
				 <div class="col-lg-12 mb-3">
				 <div class="card">
					<div class="card-body">
						<div class="table-responsive">
						    <div
							  id="route_maps"
							  class="route_map"
							  style={{ height: window.innerHeight - 250 }}
							>
							  <RouteGoogleMap
								path={this.state.path}
								route_list={this.state.student_list}
								is_open_map={1}
							  />
							</div>
					
							<div class="fl-right">
								
							</div>
						</div>

					</div>
					</div>
				 </div>
			  </div>
			</div>
         </>
		)
	}
}
export default Index;
